import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";

import { PageWrapper } from "@/components/PageWrapper";
import { HeathStats } from "./components/HealthStats";
import { Leaderboards } from "./components/Leaderboards";

type Props = RouteComponentProps;

const DashboardFC: React.FC<Props> = () => {
  return (
    <PageWrapper title="Stats" hideSeparator className="coachDashboard">
      <HeathStats />
      <Leaderboards />
    </PageWrapper>
  );
};

export const Dashboard = withRouter(DashboardFC);
